import { FOLLOW_UP_VIDEO_VISIT_SKU_ID, GENERAL_VISIT_SKU_ID } from '@/types/enums/sku-constants'

/** GM default bookable-visit SKU id when the active tenant has no `constants.sku`. */
export const BOOK_VISIT_SKU_ID = GENERAL_VISIT_SKU_ID

/** GM default detail page for the bookable visit. */
export const BOOK_VISIT_DETAIL_HREF = `/s/video-visit/${GENERAL_VISIT_SKU_ID}`

/**
 * Entry point into the first-visit booking flow for patients without a completed appointment.
 * Shared by the dashboard's "Book visit" pill and "Book a visit" row, the Visits page booking
 * callout, and the Next Steps empty state for first-time patients.
 */
export const BOOK_VISIT_HREF = `${BOOK_VISIT_DETAIL_HREF}/location-confirmation`

/**
 * Entry point into the follow-up visit booking flow for patients who already completed a visit.
 * Matches the location-confirmation path used by clinician-requested follow-up next-step cards.
 */
export const BOOK_FOLLOW_UP_VISIT_HREF = `/s/video-visit/${FOLLOW_UP_VIDEO_VISIT_SKU_ID}/location-confirmation`

/**
 * Resolves the Book a visit href: follow-up SKU when the patient has a completed appointment,
 * otherwise the general video-visit SKU.
 */
export function bookVisitHref(hasCompletedAppointment?: boolean | null): string {
    return hasCompletedAppointment ? BOOK_FOLLOW_UP_VISIT_HREF : BOOK_VISIT_HREF
}
